import React from 'react';
import { Content } from './Content';
import { Resolution886ReportFilterProvider } from '@/context/Resolution886ReportFilter';

export function Resolution886Reports(): JSX.Element {
	return (
		<Resolution886ReportFilterProvider>
			<Content />
		</Resolution886ReportFilterProvider>
	);
}
